import type {AiSubtitleGenerationLanguageSelectorPanelProps} from '@Panels/ai-subtitle-generation-language-selector-panel/ai-subtitle-generation-language-selector-panel.types';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export const PANEL_ID = 'ai-subtitle-generation-language-selector-panel';

export const openAiSubtitleGenerationLanguageSelectorModal = (props?: AiSubtitleGenerationLanguageSelectorPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AI_SUBTITLE_GENERATION_LANGUAGE_SELECTOR_MODAL,
      panelProps: {...props},
    })
  );
};
